import { z } from "zod";
import { AreaDesignation } from "@miplatform/types";

export const addAreaTypeSchema = z.object({
  name: z.string().min(1, "Area Name is required"),
  areaDesignation: z.nativeEnum(AreaDesignation),
  specColumn: z.number(),
  categories: z.array(
    z.object({
      categoryId: z.string(),
      categoryName: z.string(),
      isRequired: z.boolean(),
      displayOrder: z.number(),
    })
  ),
});
